'use client';
import { useState } from 'react';
import { FieldValues } from 'react-hook-form';

import { Button, Icon } from '@ui/components/atoms';

import { InputForm, IInputForm } from './input-form';
import { twMerge } from 'tailwind-merge';

interface IInputEditable<T extends FieldValues> extends IInputForm<T> {
  onSave(): void;
  isLoading?: boolean;
  editButtonClassName?: string;
  disableSaveButton?: boolean;
}

export function InputEditable<T extends FieldValues>({
  onSave: onSubmit,
  isLoading,
  disableSaveButton = false,
  ...props
}: IInputEditable<T>) {
  const [isEditable, setEditable] = useState(false);

  function onEdit() {
    if (props.disabled) {
      return;
    }
    setEditable(true);
  }

  async function onSave() {
    await onSubmit();
    setEditable(false);
  }

  return (
    <div className="flex items-start">
      <div className="flex-1">
        <InputForm {...props} disabled={isLoading || !isEditable || props.disabled} />
      </div>
      <Button
        isLoading={isLoading}
        disabled={props.disabled || (isEditable && disableSaveButton)}
        type={isEditable ? 'input-active' : 'input'}
        className={twMerge(
          'ml-2 min-w-[8rem] w-32 h-[52px] justify-center mt-7',
          props.editButtonClassName,
        )}
        onClick={isEditable ? onSave : onEdit}>
        {isEditable ? (
          'Save'
        ) : (
          <>
            <Icon type="edit" className="mr-2" /> Edit
          </>
        )}
      </Button>
    </div>
  );
}
